<template>
  <div class="publicvenue">
    <!-- 操作栏容器 -->
    <div class="publicvenue-info-operation-container">
      <div class="publicvenue-info-search-container">
        <!-- 搜索框 -->
        <search
          class="publicvenue-search"
          placeholder="请输入场馆名字"
          @search="publicvenueSearch"
        />
        <el-select
          class="publicvenue-select"
          v-model="status"
          placeholder="请选择"
          @change="selectStatu"
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="publicvenue-info-button-container">
        <button
          class="button add-publicvenue"
          @click="addPublicvenueDialogShow"
          v-hasPermi="'sc:publicvenue:add'"
        >
          <i class="iconfont icon-add"></i>新增场馆
        </button>
        <!-- 批量删除 -->
        <button
          class="button delete-publicvenue"
          @click="deleteClick"
          v-hasPermi="'sc:publicvenue:delete'"
        >
          <i class="iconfont icon-delete" />批量删除
        </button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="publicvenue-info-table-container" v-bitmap="getListResult">
      <publicvenueList
        class="publicvenue-list"
        v-show="total"
        :publicvenueList="publicvenueList"
        @multipleDelete="multipleDelete"
      />
    </div>
    <!-- 分页容器 -->
    <div class="publicvenue-info-pagination-catainer">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageSize)"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 新增场馆信息 -->
    <publicvenueAdd
      :dialogFormVisible.sync="isAddPublicvenueDialogShow"
      v-show="isAddPublicvenueDialogShow"
    />
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
import pagination from "@/components/pagination/pagination";
import publicvenueList from "./components/publicvenue-list/publicvenueList.vue";
import publicvenueAdd from "./components/publicvenue-add-dialog/addPublicvenue-dialog.vue";
export default {
  components: {
    search,
    pagination,
    publicvenueList,
    publicvenueAdd,
  },
  data() {
    return {
      publicvenueList: [],
      getListResult: "nullData",
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      deleteList: [],
      isAddPublicvenueDialogShow: false,
      statusList: [
        {
          label: "正常",
          value: "0",
        },
        {
          label: "停用",
          value: "1",
        },
      ],
      status: "0",
    };
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.getPublicvenueList();
  },
  methods: {
    publicvenueSearch(e) {
      this.venueName = e;
      this.refresh();
    },
    selectStatu(e) {
      this.status = e;
      this.refresh();
    },
    multipleDelete(res) {
      this.deleteList = res;
    },
    // 显示添加弹出框
    addPublicvenueDialogShow() {
      this.isAddPublicvenueDialogShow = true;
    },
    getPublicvenueList() {
      // this.getListResult = "loading";
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolId: this.user.schoolId,
        venueName: this.venueName,
        status: this.status,
      };
      this.get(this.$url.getPublicvenueList, data).then((res) => {
        // console.log("查询学校公开场馆列表==>", res);
        this.total = res.total;
        if (this.total <= 0) return (this.getListResult = "nullData");
        this.getListResult = "success";
        this.publicvenueList = res.rows;
      });
    },
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.publicvenueList = [];
      this.getPublicvenueList();
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的场馆");
      }
      this.$confirm("是否删除选中的场馆?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.delPublicvenue + "/" + this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              }
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getPublicvenueList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getPublicvenueList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./publicvenue.scss";
</style>
